import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function VisitorCounter() {
  const [stats, setStats] = useState({
    todayVisits: 0,
    totalVisits: 0,
    onlineNow: 0
  });

  useEffect(() => {
    // Track this visit
    trackVisit();
    
    // Fetch stats
    fetchStats();
    
    // Update stats every 30 seconds
    const interval = setInterval(fetchStats, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const trackVisit = async () => {
    try {
      await axios.post(`${API}/visitors/track`);
    } catch (error) {
      console.error('Error tracking visit:', error);
    }
  };

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/visitors/stats`);
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  return (
    <div className="fixed bottom-24 left-6 z-30 bg-zinc-950 border border-zinc-800 rounded-lg p-4 shadow-2xl">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
        <span className="text-xs font-bold tracking-widest text-gray-400">LIVE STATS</span>
      </div>
      
      <div className="space-y-2">
        <div className="flex items-center justify-between gap-6">
          <span className="text-xs text-gray-500">Online Now:</span>
          <span className="text-lg font-bold text-green-500">{stats.onlineNow}</span>
        </div>
        
        <div className="flex items-center justify-between gap-6">
          <span className="text-xs text-gray-500">Today:</span>
          <span className="text-lg font-bold text-white">{stats.todayVisits}</span>
        </div>
        
        <div className="flex items-center justify-between gap-6">
          <span className="text-xs text-gray-500">Total:</span>
          <span className="text-lg font-bold text-gray-400">{stats.totalVisits.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
}

export default VisitorCounter;
